import { type ConfigApp } from "./app";

export const CONFIG_PERMISSIONS_ACCESS_BY_APP_ANY: {
  [key in ConfigApp]: string[];
} = {
  admin: ["access:management-services"],
  cms: [
    "access:content",
    "access:database",
    "access:datasource",
    "access:layout",
    "access:location",
    "access:media",
    "access:operation",
    "access:post",
    "access:quiz",
    "access:scheduler",
    "access:tag",
    "access:trivia",
  ],
  wallView: ["access:location"],
};
